import BForm from "../../modules/BForm";
import BRequest from "../../modules/BRequest";

export default class BRecipeShareForm
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `[data-form="recipe-send-by-email"]`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("submit", event => {
			if (event.target.matches(this.selector())) {
				event.preventDefault();

				const shareForm = new this(event.target.closest(this.selector()));
				shareForm.submit();
			}
		});
	}

	submit()
	{
		const form = new BForm(this.el);
		const recipeId = this.el.dataset.recipeId;

		form.resetErrors();
		form.disable();

		const data = {
			emailAddress: this.el.querySelector(`[name="emailAddress"]`).value,
		};

		BRequest.post(`/api/v2/recipes/${recipeId}/share`, data).then(response => {
			form.el.reset();
			form.el.innerHTML = `<p style="text-align: center; color: #93C21F; font-weight: bold; padding: 1rem 0; margin: 0;"><span class="material-icons b-icon b-icon--left" style="vertical-align: middle;">check_circle</span>E-mail byl úspěšně odeslán.</p>`;
		}).catch(error => {
			form.setErrorResponse(error.response);
		}).finally(() => {
			form.enable();
		});
	}
}
